import React from "react";
import { Frame, Lead, Note, Tel, TextFrame } from "./styles";
import SectionTitle from "../SectionTitle";

interface Props {
	lead: string;
	tel: string;
	note: string;
	id?: string;
	windowW: number | null;
}

const Footer: React.FC<Props> = (props) => {
	const { lead, tel, note, id, windowW } = props;
	return (
		<Frame id={id} windowW={windowW}>
			<SectionTitle
				title="CONTACT"
				subtitle="ご応募・お問い合わせ"
				align="left"
				color="#FFF"
			/>
			<TextFrame>
				<Lead>{lead}</Lead>
				<Tel>
					<dt>TEL</dt>
					<dd>{tel}</dd>
				</Tel>
				<Note>{note}</Note>
			</TextFrame>
		</Frame>
	);
};

export default Footer;
